import axios from 'axios';
import { getPrivateProjectBankFileDownloadSignedUrl } from 'scenes/ProjectBank/services/private-project-bank/getPrivateProjectBankFileDownloadSignedUrl.service';

export const fetchPrivateProjectBankFile = async ({
  projectId,
  fileId,
  cancelTokenSource,
  blobUrl,
  blob,
}) => {
  if (!cancelTokenSource) cancelTokenSource = axios.CancelToken.source();

  const { downloadUrl } = await getPrivateProjectBankFileDownloadSignedUrl(
    projectId,
    fileId
  );

  const signedDownloadUrl = downloadUrl;

  try {
    if (blobUrl) {
      const blobResponse = await axios.get(signedDownloadUrl, {
        responseType: 'blob',
        cancelToken: cancelTokenSource.token, // Set the cancellation token
      });

      const blob = new Blob([blobResponse.data]);
      const url = URL.createObjectURL(blob);
      return url;
    }

    if (blob) {
      const blobResponse = await axios.get(signedDownloadUrl, {
        responseType: 'blob',
        cancelToken: cancelTokenSource.token, // Set the cancellation token
      });

      return new Blob([blobResponse.data]);
    }

    return signedDownloadUrl;
  } catch (error) {
    console.log('error fetching file:', error);
  }
};
